/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'dropdown-menu',
	templateUrl: './dropdown-menu.component.html',
	// styleUrls: ["./dropdown-menu.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent implements OnInit {
	@Output() public onOpen: EventEmitter<any> = new EventEmitter();
	@Output() public onClose: EventEmitter<any> = new EventEmitter();

	public opened$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	private _visible = false;
	constructor(private ngZone: NgZone) {}

	public ngOnInit() {}

	public toggle(): void {
		this.ngZone.run(() => {
			this._visible = !this._visible;
			this.opened$.next(this._visible);
			if (this._visible) {
				this.onOpen.emit(true);
			} else {
				this.onClose.emit(false);
			}
		});
	}

	public close(event?): void {
		this.ngZone.run(() => {
			this._visible = false;
			this.opened$.next(false);
			this.onClose.emit(false);
		});
	}
}
